/* istanbul ignore file */
import queryString from 'query-string';
import getLocationFromDom from './location-from-dom';
import getLocationFromEss from './location-from-ess';
import getLocationFromJioNews from './location-from-jio-news';
import { putInStorage, getLocationFromStore } from './location-from-storage';
import { getLocationFromNative, getNaitveLatLong } from './location-from-myjio';
import { firstSuccessfulPromise } from '../utils';

export const getLoc = async () => {
  const location = await firstSuccessfulPromise(
    [getLocationFromStore, getLocationFromEss, getLocationFromJioNews, getLocationFromNative, getLocationFromDom],
    location => Object.values(location).find(value => Boolean(value)),
    {}
  );

  return location;
};

export const getLocMyJio = async () => {
  const location = await firstSuccessfulPromise(
    [getLocationFromStore, getLocationFromNative, getLocationFromDom],
    location => Object.values(location).find(value => Boolean(value)),
    {}
  );

  return location;
};

export const getBasicLocationDetails = async () => {
  const location = await firstSuccessfulPromise(
    [getLocationFromStore, getLocationFromEss, getLocationFromJioNews, getNaitveLatLong, getLocationFromDom],
    location => Object.values(location).find(value => Boolean(value)),
    {}
  );

  return location;
};

const getLocation = async () => {
  /**
   * Check query parameter for source
   * If source is ESS, MyJio, JioNews & location coordinate is not null, save the received coordinates & skip current location
   * If source is ESS, MyJio, JioNews & location coordinate is null, store the current location
   * If source is not available in query param, store current location if user given permission
   * If source is not available in query param &  user not given permission, store null
   */
  const { latitude = '', longitude = '', source_id = '' } = queryString.parse(window.location.search);
  const location = await getLocationFromDom();
  if (source_id) {
    if (latitude && longitude) {
      putInStorage({ longitude, latitude });
      return {
        longitude, latitude
      };
    }
    putInStorage(location);
  } else {
    putInStorage(location);
  }
  return location;
};

export const getLocationCoordinates = async () => {
  const location = getLocationFromStore();
  if (location) { return location; }

  const s = await getLocation();
  return s;
};

export { getLocationFromNative, getLocationFromStore };

export default getLocation;
